// @flow
import * as React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import styled from 'styled-components';

const Bar = styled.div`
  margin-top: ${({ theme }) => theme.metrics.margin}px;
  display: flex;
  justify-content: flex-end;

  & > div {
    margin-left: ${({ theme }) => theme.metrics.smallMargin}px;
  }
`;

type Props = {
  onActionClick: () => void,
  actionText: string,
  children?: any,
}

export default function ActionBar(props: Props) {
  return (
    <Bar>
      { props.children &&
         props.children
      }
      <RaisedButton
        label={props.actionText}
        primary
        onClick={props.onActionClick}
        type="button"
      />
    </Bar>
  );
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/ActionBar.js